import { Component, OnInit } from '@angular/core';
import { PersonalInfoService } from 'src/app/services/personal-info.service';
import { ApplicationService } from 'src/app/services/application-service';
import { FlowService } from 'src/app/services/flow.service';

@Component({
  selector: 'app-start-improve',
  templateUrl: './start-improve-fi.component.html',
  styleUrls: ['./start-improve.component.scss'],
})
export class StartImproveComponent implements OnInit {
  steps!: number;
  firstName!: string;
  autoprocessing!: number;

  constructor(
    private personalInfoService: PersonalInfoService,
    private applicationService: ApplicationService,
    public flowService: FlowService
  ) {}

  ngOnInit(): void {
    this.firstName = this.personalInfoService.firstName;
    this.autoprocessing = this.applicationService.autoprocessing;
  }

  handleContinueButtonClick(): void {
    this.flowService.nextScreen();
  }
}
